import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Notice } from "@/components/Badges";

export default function Security() {
  const { user, refresh } = useAuth();
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const begin = async () => {
    const { data } = await api.post("/auth/mfa/setup");
    setSetup(data);
  };
  const act = async (path, msg) => {
    try {
      await api.post(path, { code });
      setCode("");
      setSetup(null);
      await refresh();
      toast.success(msg);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const codeInput = <input aria-label="Authenticator code" inputMode="numeric" maxLength={6} data-testid="mfa-setup-code-input" className="input font-mono sm:w-40" placeholder="123456" value={code} onChange={(e) => setCode(e.target.value)} />;
  return (
    <div className="space-y-6 fade-up">
      <PageHeader title="Security" sub="Sign-in uses Google. Add an authenticator app for a second verification step." />
      <section className="card space-y-4 p-6" data-testid="mfa-section">
        <h2 className="font-semibold text-[#0B192C]">Multi-factor authentication</h2>
        <p className="text-sm" data-testid="mfa-status">Status: <b>{user.mfa_enabled ? "On" : "Off"}</b></p>
        {!user.mfa_enabled && !setup && <button onClick={begin} data-testid="mfa-setup-button" className="btn-teal btn-sm">Set up authenticator app</button>}
        {setup && (
          <div className="space-y-3">
            <img src={`data:image/png;base64,${setup.qr_png}`} alt="QR code for authenticator app" className="h-44 w-44 rounded border" data-testid="mfa-qr" />
            <p className="text-xs text-slate-600">Or enter this key manually: <span className="font-mono" data-testid="mfa-secret">{setup.secret}</span></p>
            <div className="flex gap-2">{codeInput}<button onClick={() => act("/auth/mfa/enable", "MFA enabled")} data-testid="mfa-enable-button" className="btn-teal btn-sm">Confirm and enable</button></div>
          </div>
        )}
        {user.mfa_enabled && <div className="flex gap-2">{codeInput}<button onClick={() => act("/auth/mfa/disable", "MFA disabled")} data-testid="mfa-disable-button" className="btn-ghost btn-sm">Turn off MFA</button></div>}
      </section>
      <Notice tone="info">Workspaces are isolated: only invited members can see a workspace's projects, documents and applications. Documents are encrypted before storage and every access is logged in the workspace activity log (Business profile page).</Notice>
    </div>
  );
}
